import styled from 'styled-components';

import {
  Menu,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const ItemContainer = styled(Menu.Item)`
  align-items: center;
  display: flex;
  height: 35px;
  margin-bottom: 8px;
  padding-left: 22px;
`;

const Image = styled.img`
  ${({ visible }) => (visible ? '' : 'display: none;')}
  height: 30px;
  margin-right: 20px;
  width: 30px;
`;

const Text = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.sidebarItems};
  flex: 2;
  padding-top: 1px;
`;

const TextItemSelected = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.itemSelected};
  flex: 2;
  padding-top: 1px;
`;

const ItemSelected = styled.div`
  background: ${(props) => props.theme.color.itemSelected};
  height: 100%;
  width: 6px;
`;

export {
  Image,
  ItemContainer,
  ItemSelected,
  Text,
  TextItemSelected,
};
